import React from 'react';
import { createFileRoute } from '@tanstack/react-router';
import LocatingFloorPlans from 'containers/Dashboard/Locating/FloorPlans';
import LocatingDetails from 'containers/Dashboard/Locating/Details';
import LocatingHistory from 'containers/Dashboard/Locating/History';
import { useDashboardContext } from 'containers/Dashboard/context/DashboardContext';

function LocatingCanvas() {
  const { canvasId } = Route.useParams();
  const { teepData, facilityData, locatingFacilityData, windowSize } =
    useDashboardContext();

  if (canvasId === 'summary_details') {
    return <LocatingDetails />;
  }
  if (canvasId === 'summary_history') {
    return <LocatingHistory />;
  }
  return (
    <LocatingFloorPlans
      teepData={teepData}
      facilityData={locatingFacilityData}
      activityFacilityData={facilityData}
      windowSize={windowSize}
    />
  );
}

export const Route = createFileRoute(
  '/_authenticated/dashboard/locating/$canvasId'
)({
  component: LocatingCanvas,
});
